import { useEffect, useRef } from "react";
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  setDataInRedux,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
} from "../../actions/CommonAction";
import { BiBarChartAlt2, BiConfused, BiBell } from "react-icons/bi";
import { RxEnvelopeClosed } from "react-icons/rx";
import { FiPhoneCall } from "react-icons/fi";
import { BsCircleFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { AiOutlineLogout } from "react-icons/ai";
import userIcon from "../../assets/images/icons8-user-50.png";
import maleUserIcon from "../../assets/images/user-male.jpeg";
import femaleUserIcon from "../../assets/images/user-female.jpeg";
import WebService from "../../utility/WebService";
import WarningModal from "../Warning/Warning";
import { NavLink } from "react-router-dom";
import SucessModal from "../SucessModal/Sucess";
import { FiChevronDown } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import HelperService from "../../utility/HelperService";
import { IoAlert } from "react-icons/io5";
import { Trash3Fill, X } from "react-bootstrap-icons";
import { GrClose } from "react-icons/gr";
import { toast } from "../AppModal/AppModal";
import htmlparse from "html-react-parser";
import { sanitizeHtml } from "../../utility/sanitizeHtml";
import SpringMoneyApiEndPoints from "../SpringMoney/SpringMoneyApiEndPoints";
import Loader from "../Loader/Loader";
import ActionTooltip from "../ToolTip/ActionTooltip";
import BrokerSelectionPopup from "../SpringMoney/Transactions/BrokerSelectionPopup";
import LogoutPopup from "../SpringMoney/Transactions/LogoutPopup";
import "../AppModal/ModalKit.css";
const userNavigation = [
  { name: "Advisor Dashboard", href: "", isShow: false },
  {
    name: "Two Factor Authentication (2FA)",
    href: "/my-profile",
    isShow: false,
  },
  { name: "Agreement", href: "/admin/mis-report/agreement", isShow: false },
  { name: "Data consent", href: "/data-consent", isShow: false },
  { name: "Change Password", href: "/change-password", isShow: false },
  { name: "Sign out", href: "#", isShow: false },
];

const NotificatonDropList = [
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "25 Nov 2022",
    href: "#",
  },
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "30 Nov 2022",
    href: "#",
  },
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "4 Dec 2022",
    href: "#",
  },
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "7 Dec 2022",
    href: "#",
  },
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "10 Dec 2022",
    href: "#",
  },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

function getInitials(name?: string) {
  if (!name || !name.trim()) return "";
  const parts = name.trim().split(/\s+/);
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return (first + last).toUpperCase();
}

const Header = (props: any) => {
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState<any>([]);
  const [ShowLoader, setShowLoader] = useState(false);
  const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");
  const dispatch: Dispatch<any> = useDispatch();
  const [warningMessage, setWarningMessage] = useState<any>();
  const [isShowWarningModal, setShowWarningModal] = useState(false);
  const [isDeoDashboard, setIsDeoDashboard] = useState(false);
  const [sucessMessage, setSucessMessage] = useState<any>();
  const [isShowSucessModal, setShowSucessModal] = useState(false);
  const [announcementCount, setAnnouncementCount] = useState<any>();
  const [notification, setNotification] = useState<any>();
  const [navigation, setNavigation] = useState<any>([]);
  const [notificationCount, setNotificationCount] = useState<any>();
  const [image, setImage] = useState<any>();
  const [totalCount, setTotalCount] = useState<any>(0);
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const [checkAgreementData, setCheckAgreementData] = useState<any>();
  const [companyImageURL, setCompanyImageURL] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [showSafehandsLogoLoading, setShowSafehandsLogoLoading] =
    useState<boolean>(false);
  const [isCinet, setIsCinet] = useState(false);
  const [showBrokerSelectionPopup, setShowBrokerSelectionPopup] =
    useState<boolean>(false);
  const [brokerList, setBrokerList] = useState<any>();
  const [smallCaseNotificationDetails, setSmallCaseNotificationDetails] =
    useState<any>();
  const [logoutFromPrevBroker, setLogoutFromPrevBroker] = useState<string>();
  const [showBrokerLogoutPopup, setShowBrokerLogoutPopup] =
    useState<boolean>(false);
  const [deletingId, setDeletingId] = useState(null);
  const [expandedId, setExpandedId] = useState(null);

  let history = useNavigate();

  const SignOut = () => {
    localStorage.clear();
    dispatch(setDataInRedux({ type: USER_LOGOUT, value: "" }));
    window.location.href = "/login";
  };

  const handleLeftSideBar = () => {
    props.setIsSidebarVisible(true);
  };

  useEffect(() => {
    CheckDisplay();
    getAnnouncements();
    getList();
    getNotification();
    getCompanyDetail();

    {
      user_data.is_person == "Client" && checkAgreement();
    }

    for (var i in userNavigation) {
      if (user_data.is_person == "Admin") {
        if (userNavigation[i].name == "Sign out") {
          userNavigation[i].isShow = true;
        }
      } else {
        userNavigation[i].isShow = true;
      }
    }
    setNavigation([...userNavigation]);
  }, []);
  const checkAgreement = () => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/ClientAgreements/IsAgreementSigned`,
      body: null,
    })
      .then((res: any) => {
        setShowLoader(false);
        if (res.is_signed_agreement == false) {
          //setOpen(true);
        }
        setCheckAgreementData(res);
      })
      .catch((e) => {
        setShowLoader(false);
        // setWarningMessage(e.response.data.message)
      });
  };

  const getAnnouncements = () => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/Announcements/GetActiveAnnouncements`,
      body: null,
    })
      .then((res: any) => {
        setAnnouncementCount(res.total_count);
        setAnnouncements(res.list);
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
        // setWarningMessage(e.response.data.message)
      });
  };

  const warningCloseModal = () => {
    setShowWarningModal(false);
    setShowLoader(false);
  };

  const getList = (page?: any) => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/Discrepancy/GetDiscrepancies`,
      body: null,
    })
      .then((res: any) => {
        setTotalCount(res.total_count);
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
      });
  };

  // const getNotification = () => {
  //     setShowLoader(true)
  //     WebService.getAPI({
  //         action: `/v2/Dashboard/GetAlerts`,
  //         body: null
  //     })
  //         .then((res: any) => {
  //             setNotificationCount(res.total_count)
  //             setNotification(res.list)
  //             setShowLoader(false)
  //         })
  //         .catch((e) => {
  //             setShowLoader(false)
  //             // setWarningMessage(e.response.data.message)
  //         })
  // }

  const getNotification = () => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/NotificationDetails/GetNotifications`,
      body: null,
    })
      .then((res: any) => {
        setNotificationCount(res.total_count);
        setNotification(res.list);
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
        // setWarningMessage(e.response.data.message)
      });
  };

  // const sucessCloseModal = () => {
  //     setShowSucessModal(false)
  //     setShowLoader(false);
  //   }

  const onMyProfile = () => {
    navigate("/my-profile");
  };
  const onDataConsent = () => {
    navigate("/data-consent");
  };
  const onAgreement = () => {
    navigate("/admin/mis-report/agreement");
  };

  const onChangePassword = () => {
    navigate("/change-password");
  };
  const CheckDisplay = () => {
    var token: any = localStorage.getItem("token_pre");
    const userDetailString = localStorage.getItem("user_Detail");
    if (userDetailString) {
      const userDetail = JSON.parse(userDetailString);
      const roles = userDetail.roles;
      if (roles.some((role: any) => role.name === "Financial Planning")) {
        setIsCinet(true);
      }
    }
    if (token) {
      setIsDeoDashboard(true);
    } else {
      setIsDeoDashboard(false);
    }
  };
  const goToDeoDashboard = () => {
    var token: any = localStorage.getItem("token_pre");
    localStorage.setItem("token", token);
    localStorage.removeItem("token_pre");
    onLoginDetail(token);
  };

  const onLoginDetail = (token?: any) => {
    WebService.getAPI({
      action: `/login/me`,
    })
      .then((res: any) => {
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: { access_token: token },
        });
        localStorage.setItem("user_Detail", JSON.stringify(res.result));
        history("/dashboard");
        window.location.reload();
      })
      .catch((e) => {
        // setLoading(false)
      });
  };

  const DeleteNotification = (index: any) => {
    console.log(index);
    WebService.getAPI({
      action: `/v2/NotificationDetails/ArchiveNotification?id=${index}`,
      body: null,
    })
      .then((res: any) => {
        getNotification();
        ReadNotification(notification);
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
      });
  };

  const ReadNotification = (list: any) => {
    var temp = [];
    for (var i in list) {
      temp.push(notification[i].id);
    }
    console.log(temp);
    WebService.postAPI({
      action: `/v2/NotificationDetails/ReadNotification`,
      body: temp,
    })
      .then((res: any) => {
        getNotification();
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
      });
  };
  const onCloseModal = () => {
    history(`/admin/mis-report/agreement`);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const getCompanyDetail = () => {
    WebService.getAPI({
      action: `/CompanyMaster/CompanyDetail`,
    })
      .then((res: any) => {
        if (res) {
          if (res.image_path) {
            setCompanyImageURL(res.image_path);
          }
          setCompanyName(res.name_of_company);
        }
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
      });
  };

  const handleNotification = (notification: any) => {
    if (notification.title_name === "Smallcase") {
      setSmallCaseNotificationDetails(notification);
      // setShowBrokerLogoutPopup(true);
    }
  };

  useEffect(() => {
    if (smallCaseNotificationDetails) {
      // getBrokerListCallApi();
      jwtTokenApi();
    }
  }, [smallCaseNotificationDetails]);

  const jwtTokenApi = async () => {
    // setShowBrokerSelectionPopup(false);
    setShowSafehandsLogoLoading(true);
    const investor_id = smallCaseNotificationDetails.investor_id;
    try {
      const response = await fetch(
        `${SpringMoneyApiEndPoints.authIdAgainstInvestorId}${investor_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (data.status_code === 200) {
        setShowSafehandsLogoLoading(false);
        fetchTransactionIdApiCall(data.data);
      } else {
        setShowSafehandsLogoLoading(false);
        toast.error("error_occured, Try Again");
      }
    } catch (err) {
      setShowSafehandsLogoLoading(false);
      toast.error("error_occured, Try Again");
    }
  };

  const fetchTransactionIdApiCall = async (JwtToken: any) => {
    setShowSafehandsLogoLoading(true);
    try {
      const response = await fetch(
        `${SpringMoneyApiEndPoints.fetchTransactionIdBySpTransactionId}`,
        {
          method: "POST",
          body: JSON.stringify({
            sp_transaction_id: smallCaseNotificationDetails.sp_transaction_id,
            gateway_auth_token: JwtToken.token,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (data.status_code === 200) {
        setShowSafehandsLogoLoading(false);
        sendTransactionIdToSafehandsBackend(
          JSON.parse(smallCaseNotificationDetails.customer_advice_details_id),
          data.data.transaction_id
        );
        smallCaseSdkTrigger(JwtToken, data.data);
      } else {
        setShowSafehandsLogoLoading(false);
        toast.error("error_occured,Try Again");
      }
    } catch (err) {
      setShowSafehandsLogoLoading(false);
      toast.error("error_occured,Try Again");
    }
  };

  const smallCaseSdkTrigger = async (
    JwtToken: any,
    TransactionIdApiResponse: any
  ) => {
    const gatewayInstance = new window.scDK({
      gateway: "plan360degree",
      smallcaseAuthToken: `${JwtToken.token}`,
      config: {
        amo: false,
      },
    });

    gatewayInstance.init({ smallcaseAuthToken: JwtToken.token });
    if (JwtToken.user_type === "connected_user") {
      await gatewayInstance.brokerLogout();
    }

    gatewayInstance
      .triggerTransaction({
        transactionId: `${TransactionIdApiResponse.transaction_id}`,
        // brokers: ["kite", "angelbroking", "icici", "hdfc", "kotak", "motilal"],
      })
      .then((txnResponse: any) => {
        SmallCaseResponseSend(txnResponse);
        DeleteNotification(smallCaseNotificationDetails.id);
      })
      .catch((err: any) => {
        addErrorFromSmallCaseSdkApiCall(
          JSON.parse(smallCaseNotificationDetails.customer_advice_details_id),
          err.message
        );
        // DeleteNotification(smallCaseNotificationDetails.id);
        toast.error(err.message);
      });
  };

  const sendTransactionIdToSafehandsBackend = (
    customer_advise_details_ids: any,
    transaction_id: any
  ) => {
    WebService.postAPI({
      action: `/v2/ShareTransactionBufferDetails/RtaId`,
      body: JSON.stringify({
        customer_advice_details_id: customer_advise_details_ids,
        rta_id: transaction_id,
      }),
    })
      .then((res: any) => {
        setShowSafehandsLogoLoading(false);
      })
      .catch((e) => {
        setShowSafehandsLogoLoading(false);
      });
  };

  const addErrorFromSmallCaseSdkApiCall = (
    customer_advise_details_id: any,
    message: any
  ) => {
    setShowSafehandsLogoLoading(true);
    WebService.postAPI({
      action: `/v2/ShareTransactionBufferDetails/AddError`,
      body: JSON.stringify({
        customer_advice_details_id: customer_advise_details_id,
        comments: message,
      }),
    })
      .then((res: any) => {
        setShowSafehandsLogoLoading(false);
      })
      .catch((e) => {
        setShowSafehandsLogoLoading(false);
      });
  };

  const SmallCaseResponseSend = async (res: any) => {
    const reponse = await fetch(SpringMoneyApiEndPoints.userVerificationApi, {
      method: "POST",
      body: JSON.stringify({
        transaction_id: res.transactionId,
        broker: res.broker,
        smallcase_auth_token: res.smallcaseAuthToken,
        investor_id: `${smallCaseNotificationDetails.investor_id}`,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const timeAgo = (dateString:any) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "-";

  const diff = Date.now() - date.getTime();
  const absDiff = Math.abs(diff);

  const minutes = Math.floor(absDiff / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  // FUTURE date
  if (diff < 0) {
    if (minutes < 60) return `in ${minutes}m`;
    if (hours < 24) return `in ${hours}h`;
    return `in ${days}d`;
  }

  // PAST date
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  return `${days}d ago`;
};

  const unreadCount = announcements.filter((a:any) => !a.is_read).length;

  const markAllAsRead = () => {
    setAnnouncements(
      announcements.map((a:any) => ({ ...a, is_read: true }))
    );

    // OPTIONAL API
    // WebService.post("/announcements/mark-all-read");
  };

  const markSingleRead = (id:any) => {
    setAnnouncements(
      announcements.map((a:any) =>
        a.announcements_id === id ? { ...a, is_read: true } : a
      )
    );
  };
  const deleteAnnouncement = (id:any) => {
    if (deletingId === id) return; 
     setDeletingId(id);
     setAnnouncements((prev:any) =>
        prev.filter((item:any) => item.announcements_id !== id));

    setAnnouncementCount((count: number) =>
      Math.max(count - 1, 0)
    );
    // WebService.postAPI({
    //   action: `/v2/Announcements/DeleteAnnouncement?announcements_id=${id}`,
    //   body: null
    // })
    //   .then((res: any) => {
    //     setAnnouncements((prev:any) =>
    //     prev.filter((item:any) => item.announcements_id !== id));
    //     setDeletingId(null);
    //     getAnnouncements();
    //   })
    //   .catch((e) => {
    //   })
  };

  return (
    <>
      {showBrokerLogoutPopup && (
        <div className="fpm-overlay">
          <div className="max-h-[90vh] overflow-y-auto">
            <LogoutPopup
              setLogoutFromPrevBroker={setLogoutFromPrevBroker}
              setShowBrokerLogoutPopup={setShowBrokerLogoutPopup}
            />
          </div>
        </div>
      )}
      <Loader show={showSafehandsLogoLoading} />
      {/* <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            /> */}
      <WarningModal
        show={isShowWarningModal}
        isClose={warningCloseModal}
        message={warningMessage}
      />
      <div className="sticky top-0 z-10 flex flex-shrink-0 bg-white drop-shadow-[8px_3px_5px_rgba(0,0,0,0.050)] items-center app-header">
        <div className="flex flex-1 justify-between items-center px-8">
          <div className="mr-[4px] cursor-pointer" onClick={handleLeftSideBar}>
            <svg
              width={34}
              height={34}
              viewBox="0 0 48 48"
              fill="none"
              stroke="#7B5AEC"
              strokeWidth={4}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 12H42" />
              <path d="M6 24H42" />
              <path d="M6 36H42" />
            </svg>
          </div>
          <div
            id="update-count"
            // className="mr-3"
            className="mr-1"
            onClick={() => getList()}
          ></div>
          <div
            id="update-company-logo-img"
            // className="mr-3"
            className="mr-1"
            onClick={() => onLoginDetail()}
          ></div>
          <div
            id="update-profile-img"
            // className="mr-3"
            className="mr-1"
            onClick={() => onLoginDetail()}
          ></div>
          <div className="flex flex-1 items-center">
            {/* <div className="mr-3 ml-[48px]">
                            <img src={user_data?.company_image ? user_data?.company_image : "/images/short-logo.svg"} className="image_size" />
                        </div>  */}
            {companyImageURL && (
              <div className="mr-3 ml-2">
                <img
                  src={companyImageURL}
                  //  alt="logo"
                  height={"80px"}
                  // width={"auto"}
                  width={"80px"}
                  className=""
                />
              </div>
            )}
            <div>
              <h3 className="text-[18px] font-bold text-[#1c1f3e] leading-tight tracking-[-0.01em]">
                {user_data?.company_details?.company_name
                  ? user_data?.company_details?.company_name
                  : "-"}
              </h3>
              <p className="flex items-center gap-4 text-[#8a90a6] mt-0.5">
                <span className="text-[13px] flex items-center">
                  <RxEnvelopeClosed size={14} className="mr-1.5" />
                  {user_data?.company_details?.email
                    ? user_data?.company_details?.email
                    : "-"}
                </span>
                <span className="text-[13px] flex items-center">
                  <FiPhoneCall size={14} className="mr-1.5" />{" "}
                  {user_data?.company_details?.mobile_no
                    ? user_data?.company_details?.mobile_no
                    : "-"}
                </span>
              </p>
            </div>
          </div>
          <div className="ml-4 flex items-center md:ml-6 gap-2.5">
            <button
              type="button"
              className="hidden mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 "
              onClick={() => SignOut()}
            >
              <span className="sr-only">View notifications 2</span>
              <span className="notification-bage">
                <AiOutlineLogout size={22} className="icon" />
              </span>
              <span className="header-likn-text">Sign Out</span>
            </button>
            {user_data.is_person == "Client" && (
              <>
                {/* <button
                                    onClick={handleSmallCaseCall}
                                    type="button"
                                    className=" mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 "
                                >
                                    <span className="notification-bage">
                                        <img width={40} height={40} src="/images/smallcase.webp" />
                                    </span>
                                    <div>
                                        <span className="header-likn-text">smallcase</span>
                                    </div>
                                </button> */}
                <ActionTooltip title="Documents" placement="bottom">
                <button
                  onClick={() => history(`/action/my-document`)}
                  type="button"
                  className="flex items-center justify-center w-10 h-10 rounded-[10px] text-[#8a90a6] hover:bg-[#e5defb] hover:text-[#7b5aec] transition-colors"
                >
                  <span className="sr-only">Documents</span>
                  <span className="notification-bage">
                    <svg className="icon inline" width={22} height={22}>
                      <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#icon-folder"></use>
                    </svg>
                  </span>
                </button>
                </ActionTooltip>
                {user_data.client_type == "individual" && (
                <ActionTooltip title="Discrepancies" placement="bottom">
                <button
                  onClick={() => history(`/discrepancies`)}
                  type="button"
                  className="flex items-center justify-center w-10 h-10 rounded-[10px] text-[#8a90a6] hover:bg-[#e5defb] hover:text-[#7b5aec] transition-colors"
                >
                  <span className="sr-only">Discrepancies</span>
                  <span className="notification-bage">
                    <span className="notification-count count-dsicrp">
                      {totalCount}
                    </span>

                    <svg
                      className="icon inline"
                      width={23}
                      height={21}
                      viewBox="0 0 26 24"
                      fill="none"
                      stroke="#7C7C7C"
                      strokeWidth={1.4}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M13 1.8 L23.4 22 L2.6 22 Z" />
                      <path d="M13 9.5v5M13 18h.01" />
                    </svg>
                  </span>
                </button>
                </ActionTooltip>
                )}
              </>
            )}
            {/* <button
                            type="button"
                            className=" mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 "
                        >
                            <span className="sr-only">View notifications 3</span>
                            <span className="notification-bage">
                                 
                                <svg className="icon inline  " width={20} height={20} >
                                    <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#icon-calendar"></use>
                                </svg>
                            </span>
                            <span className="header-likn-text">Calender</span>
                        </button> */}
            {/* <button
                            type="button"
                            className=" mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500"
                        >
                            <span className="sr-only">View notifications</span>
                            <span className="notification-bage">
                                <span className="notification-count">10</span>
                               
                                <svg className="icon inline  " width={20} height={20} >
                                    <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#icon-message"></use>
                                </svg>
                            </span>
                            <span className="header-likn-text">Chat</span>
                           
                        </button> */}

            {/* Announcement DropDown */}

            {/* <Menu as="div" className="relative ml-3">
              {user_data.is_person == "Client" && (
              <>
                <div>
                  <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm mx-auto">
                    <span className="sr-only">Open user menu</span>
                    <span className="notification-bage">
                      <span className="notification-count">
                        {announcementCount ? announcementCount : 0}
                      </span>
                      <svg className="icon inline  " width={20} height={22}>
                        <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#anouce"></use>
                      </svg>
                    </span>
                  </Menu.Button>
                  <span className="header-likn-text">Announcements</span>
                </div>
              </>)}
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  w-[500px]">
                  <div className="bg-[#E9DEFF] p-3 rounded-t-lg">
                    <span className="text-[16px] font-semibold">
                      Announcements
                    </span>
                  </div>
                  {announcements?.map((item: any) => (
                    <Menu.Item key={item.name}>
                      {({ active }) => (
                        <a
                          href={item.href}
                          className={classNames(
                            active ? "bg-gray-100" : "",
                            "block px-4 py-2 text-sm text-gray-700"
                          )}
                        >
                          <div className="flex justify-between items-center">
                            <span className="text-[12px] text-gray-400">
                              {item.start_date
                                ? HelperService.getFormatedDateByDMYwith(
                                    item.start_date
                                  )
                                : "-"}
                            </span>
                            <span className="text-brand">
                              {" "}
                              <BsCircleFill size={10} />
                            </span>
                          </div>
                          <span style={{ fontWeight: "bold" }}>
                            {item.title ? item.title : "-"}
                          </span>{" "}
                          <br></br>
                          {item.content ? item.content : "-"}
                        </a>
                      )}
                    </Menu.Item>
                  ))}
                  {announcements?.length == 0 && ShowLoader == false && (
                    <div>
                      <div className="error-message-table">
                        No Announcements Found
                      </div>
                    </div>
                  )}
                </Menu.Items>
              </Transition>
            </Menu> */}
            <Menu as="div" className="relative">
              {user_data.is_person === "Client" && (
                <>
                  <div>
                    <ActionTooltip title="Announcements" placement="bottom">
                    <Menu.Button
                      className="flex items-center justify-center w-10 h-10 rounded-[10px] text-[#8a90a6] hover:bg-[#e5defb] hover:text-[#7b5aec] transition-colors"
                    >
                      <span className="sr-only">Announcements</span>
                      <span className="notification-bage">
                        <span className="notification-count count-announce">
                          {announcementCount ? announcementCount : 0}
                        </span>
                        <svg
                          className="icon inline"
                          width={22}
                          height={22}
                          style={{ transform: "scaleX(-1)" }}
                        >
                          <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#anouce"></use>
                        </svg>
                      </span>
                    </Menu.Button>
                    </ActionTooltip>
                  </div>
                </>
              )}
              {/* Dropdown */}
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-[500px] origin-top-right rounded-[16px] bg-white border border-[#e6e8ef] shadow-[0_24px_60px_-12px_rgba(28,31,62,0.35)] focus:outline-none overflow-hidden">
                  {/* Header */}
                  <div className="flex items-center gap-3 px-4 py-3.5 border-b border-[#eef0f6]">
                    <div className="w-10 h-10 rounded-[12px] bg-[#f5f2fb] text-[#7b5aec] flex items-center justify-center flex-none">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={1.8}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M4 10v4a1 1 0 0 0 1 1h2l7 4V5L7 9H5a1 1 0 0 0-1 1z" />
                        <path d="M18 9a4 4 0 0 1 0 6" />
                      </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-[15px] font-bold text-[#1c1f3e] leading-tight">
                        Announcements
                      </div>
                      <div className="text-[12px] text-[#8a90a6]">
                        {announcementCount ? announcementCount : 0} active
                      </div>
                    </div>
                    <Menu.Item>
                      {({ close }) => (
                        <button
                          onClick={close}
                          aria-label="Close announcements"
                          className="w-8 h-8 flex-none flex items-center justify-center rounded-[9px] text-[#8a90a6] hover:bg-[#f5f2fb] hover:text-[#7b5aec] transition-colors"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M6 6l12 12M18 6L6 18" />
                          </svg>
                        </button>
                      )}
                    </Menu.Item>
                  </div>
                  {/* Content */}
                  <div className="max-h-[350px] overflow-y-auto">
                    {ShowLoader && (
                      <div className="px-4 py-8 text-center text-[13px] text-[#8a90a6]">
                        Loading announcements…
                      </div>
                    )}
                    {!ShowLoader && announcements.length === 0 && (
                      <div className="px-4 py-10 text-center">
                        <div className="w-12 h-12 rounded-[14px] bg-[#f5f2fb] text-[#7b5aec] flex items-center justify-center mx-auto mb-3">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={1.8}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M4 10v4a1 1 0 0 0 1 1h2l7 4V5L7 9H5a1 1 0 0 0-1 1z" />
                            <path d="M18 9a4 4 0 0 1 0 6" />
                          </svg>
                        </div>
                        <p className="text-[13px] text-[#8a90a6]">
                          No announcements yet
                        </p>
                      </div>
                    )}
                    {!ShowLoader &&
                      announcements.map((item:any) => (
                        <Menu.Item key={item.announcements_id}>
                          {({ active }) => (
                            <div
                              className={`px-4 py-3 border-b border-[#eef0f6] transition-colors relative
                                ${active ? "bg-[#efeafc]" : ""}
                                ${!item.is_read ? "bg-[#faf8fe]" : ""}`}
                            >
                            <div className="flex justify-between items-start gap-2">
                                <div
                                  className="flex-1 cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    markSingleRead(item.announcements_id);
                                  }}
                                >
                                  {/* <span className="text-[12px] text-gray-600">
                                    {item.start_date
                                      ? HelperService.getFormatedDateByDMYwith(item.start_date)
                                      : "-"}
                                  </span>
                                  <p
                                    className={`text-sm ${
                                      item.is_read ? "text-gray-900" : "font-semibold"
                                    }`}
                                  >
                                    {item.title}
                                  </p> */}
                                  <div className="flex justify-between items-start">
                                    <p
                                      className={`text-[13.5px] text-[#1c1f3e] ${
                                        item.is_read ? "" : "font-semibold"
                                      }`}
                                    >
                                      {item.title}
                                    </p>
                                    {item.start_date && (
                                      <span className="text-[12px] text-[#8a90a6] whitespace-nowrap ml-2">
                                        {HelperService.getFormatedDateByDMYwith(item.start_date)}
                                      </span>
                                    )}
                                  </div>
                                  <p
                                    className={`text-[13px] text-[#8a90a6] break-words ${
                                      expandedId === item.announcements_id ? "" : "line-clamp-2"
                                    }`}
                                  >
                                    {item.content || "-"}
                                  </p>

                                  {item.content && item.content.length > 120 && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setExpandedId(
                                          expandedId === item.announcements_id
                                            ? null
                                            : item.announcements_id
                                        );
                                      }}
                                      className="text-xs text-brand mt-1"
                                    >
                                      {expandedId === item.announcements_id ? "Show less" : "Read more"}
                                    </button>
                                  )}
                                  {item.end_date && (
                                    <p className="mt-2 text-[12px] text-[#8a90a6] italic">
                                      Note : This announcement will disappear on{" "}
                                      <span className="font-medium">
                                        {HelperService.getFormatedDateByDMYwith(item.end_date)}
                                      </span>
                                    </p>
                                  )}
                                </div>
                                {/* Delete Button */}
                                {/* <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    deleteAnnouncement(item.announcements_id);
                                  }}
                                  className="text-gray-400 hover:text-red-500 transition mt-1"
                                >
                                  ✕
                                </button> */}
                              </div>
                            </div>
                          )}
                        </Menu.Item>
                      ))}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>

            {/* Notification dropdown */}
            {user_data.is_person == "Client" && //Sourabh Added this condition on 02-Feb-2026 as per discussion with Viraj Sir.
              <Menu as="div" className="relative">
                <div>
                  <ActionTooltip title="Notifications" placement="bottom">
                  <Menu.Button
                    className="flex items-center justify-center w-10 h-10 rounded-[10px] text-[#8a90a6] hover:bg-[#e5defb] hover:text-[#7b5aec] transition-colors"
                  >
                    <span className="sr-only">Notifications</span>
                    <span className="notification-bage">
                      <span className="notification-count count-notify">
                        {notificationCount ? notificationCount : 0}
                      </span>
                      <svg
                        className="icon inline"
                        width={22}
                        height={22}
                        onClick={() => {
                          ReadNotification(notification);
                        }}
                      >
                        <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#bell"></use>
                      </svg>
                    </span>
                  </Menu.Button>
                  </ActionTooltip>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-[500px] origin-top-right rounded-[16px] bg-white border border-[#e6e8ef] shadow-[0_24px_60px_-12px_rgba(28,31,62,0.35)] focus:outline-none overflow-hidden">
                    <div className="flex items-center gap-3 px-4 py-3.5 border-b border-[#eef0f6]">
                      <div className="w-10 h-10 rounded-[12px] bg-[#f5f2fb] text-[#7b5aec] flex items-center justify-center flex-none">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={1.8}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6" />
                          <path d="M10 20a2 2 0 0 0 4 0" />
                        </svg>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="text-[15px] font-bold text-[#1c1f3e] leading-tight">
                          Notifications
                        </div>
                        <div className="text-[12px] text-[#8a90a6]">
                          {notificationCount ? notificationCount : 0} unread
                        </div>
                      </div>
                      <Menu.Item>
                        {({ close }) => (
                          <button
                            onClick={close}
                            aria-label="Close notifications"
                            className="w-8 h-8 flex-none flex items-center justify-center rounded-[9px] text-[#8a90a6] hover:bg-[#f5f2fb] hover:text-[#7b5aec] transition-colors"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M6 6l12 12M18 6L6 18" />
                            </svg>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                    <div className="max-h-[350px] overflow-y-auto">
                      {ShowLoader && (
                        <div className="px-4 py-8 text-center text-[13px] text-[#8a90a6]">
                          Loading notifications…
                        </div>
                      )}
                      {!ShowLoader &&
                        (!notification || notification.length === 0) && (
                          <div className="px-4 py-10 text-center">
                            <div className="w-12 h-12 rounded-[14px] bg-[#f5f2fb] text-[#7b5aec] flex items-center justify-center mx-auto mb-3">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={1.8}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6" />
                                <path d="M10 20a2 2 0 0 0 4 0" />
                              </svg>
                            </div>
                            <p className="text-[13px] text-[#8a90a6]">
                              You're all caught up
                            </p>
                          </div>
                        )}
                    {/* {notification?.length > 0 && notification.map((item: any) => (
                                          <Menu.Item key={item.description}>

                                              {({ active }) => (
                                                  <a
                                                      href={item.href}
                                                      className={classNames(
                                                          active ? 'bg-gray-100' : '',
                                                          'block px-4 py-2 text-sm text-gray-700'
                                                      )}
                                                  >
                                                      <div className="flex justify-between items-center">
                                                          <span className="text-[15px] " style={{ color: item.color }}>{item.description ? item.description : "-"}</span>
                                                          <span className="text-brand"> <BsCircleFill size={10} style={{ color: item.color }} /></span>
                                                      </div>
                                                      <p style={{ color: item.color }}>{item.expiry_date ? HelperService.getFormatedDateByDMYwith(item.expiry_date) : "-"}</p>

                                                  </a>
                                              )}
                                          </Menu.Item>
                                      ))} */}

                    {notification?.length > 0 &&
                      notification.map((item: any) => (
                        // <Menu.Item key={item.title_name}>
                        //   {({ active }) => (
                        //     <div className="">
                        //       <a
                        //         href={"#"}
                        //         className={classNames(
                        //           active ? "bg-gray-100" : "",
                        //           "block px-4 py-2 text-sm text-gray-700"
                        //         )}
                        //       >
                        //         <div className="flex justify-between items-center ">
                        //           <span
                        //             onClick={() => handleNotification(item)}
                        //             className="text-[15px] "
                        //             style={{ color: "black" }}
                        //           >
                        //             {item.title_name}
                        //           </span>
                        //           <span className="text-brand closebtn">
                        //             <button
                        //               type="button"
                        //               className="btn-close"
                        //               data-bs-dismiss="block"
                        //               aria-label="Close"
                        //               onClick={(e) => {
                        //                 DeleteNotification(item.id);
                        //               }}
                        //             >
                        //               <GrClose size={12} />
                        //             </button>
                        //           </span>
                        //         </div>
                        //         <p onClick={() => handleNotification(item)}>
                        //           {htmlparse(item.message)}
                        //         </p>
                        //       </a>
                        //     </div>
                        //   )}
                        // </Menu.Item>

                        <Menu.Item key={item.title_name}>
                          {({ active }) => (
                            <div
                              className={classNames(
                                active ? "bg-[#efeafc]" : "",
                                "px-4 py-3 border-b border-[#eef0f6] transition-colors"
                              )}
                            >
                              <div className="flex justify-between items-start gap-2">
                                <span
                                  onClick={() => handleNotification(item)}
                                  className="text-[13.5px] font-semibold text-[#1c1f3e] cursor-pointer"
                                >
                                  {item.title_name}
                                </span>
                                <button
                                  type="button"
                                  aria-label="Delete notification"
                                  className="text-[#b8bccb] hover:text-[#e5484d] transition-colors mt-0.5 flex-none"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    DeleteNotification(item.id);
                                  }}
                                >
                                  <GrClose size={12} />
                                </button>
                              </div>
                              <p
                                onClick={() => handleNotification(item)}
                                className="text-[13px] text-[#8a90a6] break-words cursor-pointer mt-1"
                              >
                                {htmlparse(sanitizeHtml(item.message))}
                              </p>
                            </div>
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            }

            {user_data.is_person == "Client" && (
              <div className="h-8 w-px bg-[#e6e8ef] ml-2.5"></div>
            )}
            {/* Profile dropdown */}
            {
              <Menu as="div" className="relative">
                <div>
                  <Menu.Button className="flex items-center gap-2.5 rounded-full bg-[#f5f2fb] hover:bg-[#e5defb] border border-[#e6e8ef] pl-1 pr-3 py-1 transition-colors max-w-xs">
                    <span className="sr-only">Open user menu</span>
                    {user_data.user_image ? (
                      <img
                        className="rounded-full object-cover h-[50px] w-[50px] flex-none"
                        src={user_data.user_image}
                      />
                    ) : (
                      <span
                        className="flex items-center justify-center rounded-full h-[50px] w-[50px] flex-none text-white font-bold text-[17px]"
                        style={{
                          background:
                            "linear-gradient(145deg, #7b5aec, #6344c9)",
                        }}
                      >
                        {getInitials(user_data.name)}
                      </span>
                    )}
                    <span className="flex flex-col items-start leading-tight min-w-0">
                      {user_data.is_person && (
                        <span className="text-[9.5px] font-bold tracking-wider uppercase text-[#7b5aec]">
                          {user_data.is_person}
                        </span>
                      )}
                      <span className="text-[14px] font-semibold text-[#1c1f3e] max-w-[150px] truncate">
                        {user_data.name ? user_data.name : "-"}
                      </span>
                    </span>
                    <FiChevronDown
                      className="text-[#7C7C7C] flex-none ml-0.5"
                      size={18}
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-[16px] bg-white border border-[#e6e8ef] shadow-[0_24px_60px_-12px_rgba(28,31,62,0.35)] focus:outline-none overflow-hidden">
                    <div className="py-1.5">
                    {navigation.map((item: any) => (
                      <Menu.Item key={item.name}>
                        {({ active }) => (
                          <>
                            {item.name != "Advisor Dashboard" &&
                              item.name != "Agreement" &&
                              item.isShow && (
                                <div
                                  onClick={() =>
                                    item.name == "Sign out"
                                      ? SignOut()
                                      : item.name ==
                                        "Two Factor Authentication (2FA)"
                                      ? onMyProfile()
                                      : item.name == "Change Password"
                                      ? onChangePassword()
                                      : item.name == "Data consent"
                                      ? onDataConsent()
                                      : ""
                                  }
                                  className={classNames(
                                    item.name === "Sign out"
                                      ? active
                                        ? "bg-[#fdecec] text-[#e5484d]"
                                        : "text-[#e5484d]"
                                      : active
                                      ? "bg-[#efeafc] text-[#7b5aec]"
                                      : "text-[#3d4257]",
                                    "block px-4 py-2.5 text-[13.5px] font-medium cursor-pointer transition-colors"
                                  )}
                                >
                                  {item.name}
                                </div>
                              )}

                            {isDeoDashboard &&
                              item.name == "Advisor Dashboard" &&
                              item.isShow && (
                                <div
                                  onClick={() => goToDeoDashboard()}
                                  className={classNames(
                                    active
                                      ? "bg-[#efeafc] text-[#7b5aec]"
                                      : "text-[#3d4257]",
                                    "block px-4 py-2.5 text-[13.5px] font-medium cursor-pointer transition-colors"
                                  )}
                                >
                                  {item.name}
                                </div>
                              )}
                            {(isDeoDashboard || isCinet) &&
                              item.name == "Agreement" &&
                              item.isShow && (
                                <div
                                  onClick={() => onAgreement()}
                                  className={classNames(
                                    active
                                      ? "bg-[#efeafc] text-[#7b5aec]"
                                      : "text-[#3d4257]",
                                    "block px-4 py-2.5 text-[13.5px] font-medium cursor-pointer transition-colors"
                                  )}
                                >
                                  {item.name}
                                </div>
                              )}
                          </>
                        )}
                      </Menu.Item>
                    ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            }
          </div>
        </div>
      </div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[1050]"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-[rgba(28,31,62,0.55)] transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-[1050] overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="fpm-panel fpm-sm">
                  <div className="fpm-modal">
                    <div className="fpm-head">
                      <div className="fpm-badge fpm-badge-red">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><path d="M12 9v4" /><path d="M12 17h.01" /></svg>
                      </div>
                      <Dialog.Title as="h2">Alert</Dialog.Title>
                    </div>
                    <p className="fpm-msg">{checkAgreementData?.message}</p>
                    {checkAgreementData?.id && (
                      <div className="fpm-foot">
                        <button
                          type="button"
                          className="fpm-btn-brand"
                          onClick={() => onCloseModal()}
                        >
                          {checkAgreementData?.button_title}
                        </button>
                        <button
                          type="button"
                          className="fpm-btn"
                          onClick={() => handleClose()}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default Header;
